// CapaSource Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { capaSourceConfig } from './capaSourceConfig';
import { createCapaSourceValidation } from './capaSourceValidation';

/**
 * Initialize the capaSource module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  capaSourceConfig,
  createCapaSourceValidation
);

/**
 * Create the CapaSourcePage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const CapaSourcePage = createModulePage(
  initializedConfig,
  {
    displayName: 'CapaSourcePage',
    description: 'CAPA Source Management System - Manage sources that trigger CAPA processes'
  }
);

export default CapaSourcePage;
